import { useQuery } from '@tanstack/react-query';
import { searchKeys } from '../search.keys';
import { searchService } from '../searchService';
import type { SearchResponse } from '../types';

interface UseSearchOptions {
  enabled?: boolean;
  limit?: number;
  minSearchLength?: number;
  staleTime?: number;
  gcTime?: number;
}

export function useSearch(searchTerm: string, options: UseSearchOptions = {}) {
  const {
    enabled = true,
    limit = 8,
    minSearchLength = 2,
    staleTime = 30 * 1000,
    gcTime = 5 * 60 * 1000,
  } = options;

  const shouldFetch = enabled && searchTerm.length >= minSearchLength;

  return useQuery<SearchResponse, Error>({
    queryKey: searchKeys.query(searchTerm, limit),
    queryFn: async ({ signal }) => {
      return searchService.search({ q: searchTerm, limit, signal });
    },
    enabled: shouldFetch,
    staleTime,
    gcTime,
    retry: 2,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    throwOnError: false,
    placeholderData: previousData => previousData,
  });
}
